import styled from 'styled-components'

import { color, media, radius, spacing } from '../../../themes'

export const Container = styled.div`
  width: 100%;

  ${media.tablet} {
    min-width: 382px;
    max-width: 452px;
  }
`

export const Content = styled.div`
  background: ${color('gray.05')};
  border-radius: ${radius('md')};
  white-space: pre-wrap;
  display: flex;
  flex-direction: column;
  padding: ${spacing(4, 5)};
  margin-top: ${spacing(8)};
`
